import React, { Component } from "react";

export let settings = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 6,
        slidesToScroll: 2,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 850,
      settings: {
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 650,
      settings: {
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
  ],
};

export let settings2 = {
  focusOnSelect: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 800,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 550,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings3 = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 6,
        slidesToScroll: 2,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
  ],
};

export let settings4 = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 900,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 550,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings5 = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 900,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 550,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings6 = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 900,
      settings: {
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 400,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings7 = {
  //dots: true,
  className: "center",
  centerMode: true,
  focusOnSelect: true,
  centerPadding: "60px",
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  // slidesToScroll: 1,
  // initialSlide: 0,
  rows: 2,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 900,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
        centerMode: false,
        rows: 1,
      },
    },
    {
      breakpoint: 500,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        centerMode: false,
      },
    },
  ],
};

export let settings8 = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 800,
      settings: {
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings9 = {
  //dots: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 900,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings10 = {
  //dots: true,
  focusOnSelect: true,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 800,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
};

export let settings11 = {
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  rows: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
        rows: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
        rows: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        rows: 1,
      },
    },
    {
      breakpoint: 450,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
      },
    },
  ],
};

export let settings12 = {
  //dots: true,
  focusOnSelect: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        // dots: true
      },
    },
    {
      breakpoint: 900,
      settings: {
        focusOnSelect: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
